export function clone<S>(data: S): S {
  if (data) {
    return JSON.parse(JSON.stringify(data));
  } else {
    return data;
  }
}
